import { get, omitBy, isNil } from 'lodash'
import Cookies from 'js-cookie'
import URL from 'url'
import config from 'config'

export const getTheme = ([path]) => props => get(props, `theme.${path}`)
export const callAPI = async ({ fullURL, url, method, query, body }) => {
  const response = await fetch( // eslint-disable-line
    `${fullURL || `${config.cloudAPIHost}${encodeURI(url)}`}${URL.format({ query })}`,
    omitBy({
      method: method || (body ? 'POST' : 'GET'),
      headers: omitBy({
        'Content-Type': 'application/json; charset=utf-8',
        'access_token': Cookies.get('accessToken')
      }, isNil),
      body: body ? JSON.stringify(body) : undefined
    }, isNil)
  )
  if (response.status === 200) {
    const json = await response.json()
    return Promise.resolve(json)
  } else if (response.status === 401) {
    if (!(['login', 'me']).some(key => url.indexOf(key) > -1)) {
      window.location.href = '/login'
    }
  } else {
    return Promise.reject({ statusCode: response.status, reason: json }) // eslint-disable-line
  }
}

export const formatComma = (number = '') =>
  (isNaN(number) ? number.replace(/,/g, '') : `${number}`).replace(/./g, (c, i, a) => i && c !== '.' && ((a.length - i) % 3 === 0) ? ',' + c : c)

export const getVimeoId = (url = '') => {
  const match = url.match(/^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/)
  return (match && match.length > 5 && match[5]) ? match[5] : ''
}
export const formatThaiDuration = (duration) => {
  const hours = Math.floor(duration / 3600)
  const hourString = hours ? `${hours} ชั่วโมง ` : ''
  const minutes = Math.floor(duration / 60) % 60
  const minuteString = (hours || minutes) ? `${minutes} นาที ` : ''
  const seconds = duration % 60
  return `${hourString}${minuteString}${seconds} วินาที`
}

export const uploadToS3 = ({ url, file, contentType, contentEncoding }) => {
  let xhr = new XMLHttpRequest() // eslint-disable-line
  xhr.open('PUT', url, true)
  if (contentType) { xhr.setRequestHeader('Content-Type', contentType) }
  xhr.send(file)
  return new Promise((resolve, reject) => {
    xhr.onload = (e) => {
      console.log(e, xhr)
      if (xhr.status === 200) {
        resolve(url.split('?')[0])
      } else {
        reject(xhr.status)
      }
    }
  })
}

export const viewportWidth = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return 0
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
}

export const viewportHeight = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return 0
  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
}



// WEBPACK FOOTER //
// ./src/helpers.js